
export const mostrarErroresEnFormulario = (errorsObject, formElement = null) => {
  const targetForm = formElement || document.querySelector('form:last-of-type') || document;

  // Limpiar errores anteriores
  targetForm.querySelectorAll('.form-error, .border-error').forEach(el => {
    el.classList.remove('form-error', 'border-error');
  });
  targetForm.querySelectorAll('.helper-error').forEach(el => {
    el.remove();
  });

  // Aplicar nuevos errores
  Object.entries(errorsObject).forEach(([fieldName, errorMessage]) => {
    if (!errorMessage) return;

    // Manejo especial para el grupo de roles
    if (fieldName === 'rolesSelect') {
      const rolesSection = targetForm.querySelector('.inline-group');
      if (rolesSection) {
        rolesSection.classList.add('border-error');

        const errorSpan = document.createElement('span');
        errorSpan.className = 'helper-error';
        errorSpan.textContent = errorMessage;
        rolesSection.parentElement.appendChild(errorSpan);
      }
      return;
    }

    // Manejo especial para campos de fecha
    if (fieldName === 'fechaDesde' || fieldName === 'fechaHasta' || fieldName === 'fechaSolicitud') {
      // Buscar el campo específico primero
      const field = targetForm.querySelector(`[name="${fieldName}"]`);
      if (field) {
        // Buscar el contenedor datepicker-wrapper más cercano al campo específico  form-error
        const seccionBorderError = field.closest('.form-group') || field.parentElement.closest('.form-group');
        if (seccionBorderError)
          seccionBorderError.classList.add('form-error');

        const seccion = field.closest('.datepicker-wrapper') || field.parentElement.closest('.datepicker-wrapper');
        if (seccion) {
          const errorSpan = document.createElement('span');
          errorSpan.className = 'helper-error';
          errorSpan.textContent = errorMessage;
          seccion.appendChild(errorSpan);
        }
      }
      return;
    }

    // Manejo especial para multiselect
    if (fieldName === 'multiselect') {
      const multiselectGroup = targetForm.querySelector('.multi-select[name="multiselect"]');
      if (multiselectGroup) {

        multiselectGroup.classList.add("multi-select-error")
        if (!multiselectGroup.nextElementSibling || !multiselectGroup.nextElementSibling.classList.contains('helper-error')) {
          const errorSpan = document.createElement('span');
          errorSpan.className = 'helper-error';
          errorSpan.textContent = errorMessage;
          multiselectGroup.after(errorSpan);
        }
      }
      return;
    }

    // Manejo especial para los dropzone
    if (['archivoPlantilla', 'certificadoMedico', 'archivoLote', 'listaUsuarios'].includes(fieldName)) {
      const section = targetForm.querySelector(`.carga-documento-section[name="${fieldName}"]`);
      if (section) {
        // 1. añade clase de error al contenedor
        section.classList.add('carga-documento-error');

        // 2. evita duplicar helpers
        if (!section.nextElementSibling || !section.nextElementSibling.classList.contains('helper-error')) {
          const errorSpan = document.createElement('span');
          errorSpan.className = 'helper-error';
          errorSpan.textContent = errorMessage;

          // 3. insértalo como hermano inmediatamente después
          section.after(errorSpan);               // ← o usa insertAdjacentElement('afterend', errorSpan)
        }
      }
      return;
    }

    // Manejo para campos normales
    const field = targetForm.querySelector(`[name="${fieldName}"]`);
    if (!field) return;

    const container = field.closest('.form-group') || field.parentElement;
    if (!container) return;

    container.classList.add('form-error');

    const errorSpan = document.createElement('span');
    errorSpan.className = 'helper-error';
    errorSpan.textContent = errorMessage;
    container.appendChild(errorSpan);
  });
};

// Función para limpiar errores de un campo específico (adaptada)
export const limpiarErrorCampo = (fieldName, formElement = null) => {
  const targetForm = formElement || document.querySelector('form:last-of-type') || document;

  // Manejo especial para el grupo de roles
  if (fieldName === 'rolesSelect') {
    const rolesSection = targetForm.querySelector('.inline-group');
    if (rolesSection) {
      rolesSection.classList.remove('border-error');

      const errorSpan = rolesSection.parentElement.querySelector('.helper-error');
      if (errorSpan) {
        errorSpan.remove();
      }
    }
    return;
  }

  // Manejo especial para campos de fecha
  if (fieldName === 'fechaDesde' || fieldName === 'fechaHasta' || fieldName === 'fechaSolicitud') {
    const field = targetForm.querySelector(`[name="${fieldName}"]`);
    if (field) {
      const seccion = field.closest('.form-group') || field.parentElement.closest('.form-group');
      if (seccion) {
        seccion.classList.remove('form-error');

        const errorSpan = seccion.querySelector('.helper-error');
        if (errorSpan) {
          errorSpan.remove();
        }
      }
    }
    return;
  }

  if (['archivoPlantilla', 'certificadoMedico', 'archivoLote', 'listaUsuarios'].includes(fieldName)) {
    const section = targetForm.querySelector(`.carga-documento-section[name="${fieldName}"]`);
    if (section) {
      section.classList.remove('carga-documento-error');

      const next = section.nextElementSibling;
      if (next && next.classList.contains('helper-error')) {
        next.remove();
      }
    }
    return;
  }

  // Manejo especial para multiselect
  if (fieldName === 'multiselect') {
    const multiselectGroup = targetForm.querySelector('.multi-select[name="multiselect"]');
    if (multiselectGroup) {
      multiselectGroup.classList.remove('multi-select-error')
      const next = multiselectGroup.nextElementSibling;
      if (next && next.classList.contains('helper-error')) {
        next.remove();
      }
    }
    return;
  }

  // Manejo para campos normales
  const field = targetForm.querySelector(`[name="${fieldName}"]`);
  if (!field) return;

  const container = field.closest('.form-group') || field.parentElement;
  if (!container) return;

  container.classList.remove('form-error');

  const errorSpan = container.querySelector('.helper-error');
  if (errorSpan) {
    errorSpan.remove();
  }
};

// Función para configurar la limpieza automática (adaptada para tu formulario)
export const configurarLimpiezaAutomatica = (formElement = null) => {
  const targetForm = formElement || document.querySelector('form:last-of-type');
  if (!targetForm) return;

  // Campos normales del formulario (INCLUYE input[type="file"])
  const campos = targetForm.querySelectorAll('input[type="text"], input[type="email"], input[type="file"], select');

  campos.forEach(campo => {
    // Para campos file, solo usamos 'change' ya que 'input' y 'focus' no son tan relevantes
    const eventos = campo.type === 'file' ? ['change'] : ['input', 'change', 'focus'];

    eventos.forEach(evento => {
      campo.addEventListener(evento, () => {
        limpiarErrorCampo(campo.name, targetForm);
      });
    });
  });

  // Manejo especial para checkboxes de roles
  const checkboxesRoles = targetForm.querySelectorAll('.inline-group input[type="checkbox"]');
  checkboxesRoles.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      limpiarErrorCampo('rolesSelect', targetForm);
    });
  });

  // Manejo especial para campos de fecha
  const camposFecha = targetForm.querySelectorAll('input[name="fechaDesde"], input[name="fechaHasta"]');
  camposFecha.forEach(campo => {
    const eventos = ['input', 'change', 'focus'];

    eventos.forEach(evento => {
      campo.addEventListener(evento, () => {
        limpiarErrorCampo(campo.name, targetForm);
      });
    });
  });

  // Manejo especial para multiselect
  const multiselect = targetForm.querySelector('.form-group[name="multiselect"] .multi-select');
  if (multiselect) {
    multiselect.addEventListener('click', () => {
      limpiarErrorCampo('multiselect', targetForm);
    });
  }
};

// Función para limpiar todos los errores del formulario
export const limpiarTodosLosErrores = (formElement = null) => {
  const targetForm = formElement || document.querySelector('form:last-of-type') || document;

  targetForm.querySelectorAll('.form-error, .border-error').forEach(el => {
    el.classList.remove('form-error', 'border-error');
  });
  targetForm.querySelectorAll('.helper-error').forEach(el => {
    el.remove();
  });
};

// Integración con tu método handleInput existente
export const integrarConHandleInput = (component, originalHandleInput) => {
  return function (event) {
    // Ejecutar la lógica original
    originalHandleInput.call(component, event);

    // Limpiar error del campo específico
    limpiarErrorCampo(event.target.name);

    // Limpiar del estado si es necesario
    if (component.state.errors && component.state.errors[event.target.name]) {
      component.setState(prevState => ({
        errors: {
          ...prevState.errors,
          [event.target.name]: null
        }
      }));
    }
  };
};

export const integrarConHandleUpload = (component, originalHandleUpload) => {
  return function (event) {
    // Ejecutar la lógica original
    originalHandleUpload.call(component, event);

    // Limpiar error del campo de archivo
    limpiarErrorCampo(event.target.name);

    // Limpiar del estado si es necesario
    if (component.state.errors && component.state.errors[event.target.name]) {
      component.setState(prevState => ({
        errors: {
          ...prevState.errors,
          [event.target.name]: null
        }
      }));
    }
  };
};

// Integración con tu método chkclick existente para los roles
export const integrarConChkClick = (component, originalChkClick) => {
  return function (event) {
    // Ejecutar la lógica original
    originalChkClick.call(component, event);

    // Limpiar error de roles
    limpiarErrorCampo('rolesSelect');

    // Limpiar del estado si es necesario
    if (component.state.errors && component.state.errors.rolesSelect) {
      component.setState(prevState => ({
        errors: {
          ...prevState.errors,
          rolesSelect: null
        }
      }));
    }
  };
};
